<template>
    <div>
      <card class="cursor-pointer mb-2">
          <div class="p-3 text-center carestack"
           :class="{'active' : integrated}"
           @click="open()">
              <img class="pt-3" src="/img/carestack-logo.svg" style="max-height: 60px"/>
          </div>
      </card>

        <modal ref="modal"
            size="lg"
            @hide="close()"
            :scrollable="true"
            :has-footer="false">

            <template slot="title">Carestack Integration</template>
            <transition name="fade-in-down">
              <div v-if="integrated">
                <div v-if="!editMode">
                  <div v-if="!logsMode">
                    <div class="alert alert-success">
                      <div>
                        <span> Your credentials have been verified! </span>

                        <button-loading type="button" class="btn btn-danger ml-2 float-right"
                            :loading="location_form.submitting"
                            @click="removeCarestackCredentials">
                            Remove Api Credentials
                        </button-loading>
                      </div>
                    </div>
                    <div class="mb-4 text-right">
                        <button type="button" class="btn btn-primary" @click="startEdit(null)">
                            New connection
                        </button>
                    </div>
                    <div style="max-height: calc(100vh - 220px);overflow-y: auto;overflow-x: hidden;">
                        <transition-group name="slide-right" tag="p" @leave="transitioningDone()">
                            <div class="card card-default card-default mb-2"
                                v-for="connection in carestackConnections"
                                :key="connection.id">
                                <div class="card-header d-flex pb-1">
                                    <p class="text-dark">
                                        <small class="text-muted">
                                            Campaign: {{ connection.campaign_name }}
                                        </small>
                                    </p>
                                    <div class="ml-auto">
                                        <button title="Logs"
                                            type="button"
                                            class="btn btn-default btn-sm btn-icon ml-1"
                                            @click="loadLogs(connection)">
                                            <i class="fa fa-fw fa-history"></i>
                                        </button>
                                        <button title="Edit"
                                            type="button"
                                            class="btn btn-default btn-sm btn-icon ml-1"
                                            @click="startEdit(connection)">
                                            <i class="fa fa-fw fa-pencil-alt"></i>
                                        </button>
                                        <button title="Delete"
                                            type="button"
                                            class="btn btn-default btn-sm btn-icon ml-1"
                                            @click="(evt) => {remove(connection, evt)}">
                                            <i class="fa fa-fw fa-trash"></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="card-body p-1">
                                    <div class="text-right pr-2">
                                        <small class="font-italic text-muted">
                                            Last Synced at:
                                            {{ connection.last_synced_at || 'not synced'}}
                                        </small>
                                    </div>
                                </div>
                            </div>
                        </transition-group>
                    </div>
                    <transition name="fade">
                        <div v-if="empty" class="card card-default m-0 p-3 empty-placeholder"
                            @click="startEdit(null)">
                            <div class="card-body text-center" title="Add new connection">
                                <i class="fa fa-plus" style="font-size: 1.285rem;"></i>
                                <div>Add your first connection</div>
                            </div>
                        </div>
                    </transition>
                  </div>
                  <div v-if="logsMode">
                     <card-spinner v-if="loadingLogs"></card-spinner>
                     <div v-else>
                         <div style="max-height: calc(100vh - 300px); overflow: auto;">
                             <table class="table table-hover table-striped table-light table-sm mb-0">
                                 <thead>
                                 <tr>
                                     <th class="pl-3">Result</th>
                                     <th>Appointment Date</th>
                                     <th>Patient Name</th>
                                     <th>Appointment Status</th>
                                     <th>Provider IDs</th>
                                     <th>Practice ID</th>
                                 </tr>
                                 </thead>
                                 <tbody>
                                 <template v-for="(log,index) in logs.data">
                                     <tr>
                                         <td>
                                             <span
                                                 class="badge px-2 py-1 text-uppercase"
                                                 data-toggle="collapse"
                                                 :data-target="`#accordion${index}`"
                                                 :class="statusClassOf(log)"
                                                 v-tooltip="tooltipFor(log)">
                                                 {{ log.result_status }}
                                                 <i class="fa fa-chevron-down"></i>
                                             </span>
                                         </td>
                                         <td>{{log.appointment_date}}</td>
                                         <td>{{log.patient_name}}</td>
                                         <td>{{log.status}}</td>
                                         <td>{{log.provider_ids}}</td>
                                         <td>{{log.office_id}}</td>
                                     </tr>
                                     <tr>
                                         <td colspan="8" class="p-0">
                                             <div :id="`accordion${index}`" class="collapse p-1">
                                                 <pre><code>{{ log.errors }}</code></pre>
                                             </div>
                                         </td>
                                     </tr>
                                     <tr>
                                         <td colspan="8" class="p-0">
                                             <div :id="`note${index}`" class="collapse p-1">
                                                 <pre class="text-wrap">{{ log.appointment_notes }}</pre>
                                             </div>
                                         </td>
                                     </tr>
                                 </template>
                                 </tbody>
                             </table>
                         </div>
                         <pagination class="mb-0 mt-3" :meta="logs.meta"
                             :links="logs.links"
                             @page="fetchAppointmentLogs"></pagination>
                         <div class="text-right">
                             <button @click="closeLogs()" class="btn btn-default mt-2">Back</button>
                         </div>
                     </div>
                 </div><!-- end of logsMode -->
                </div> <!-- end of !editmode -->
                  <div v-if="editMode">
                    <div class="form-group" :class="{'is-invalid': form.errors.has('campaign_id')}">
                        <label>Campaign</label>
                        <select class="form-control" v-model="form.campaign_id">
                            <option :value="null"></option>
                            <option v-for="campaign in campaigns"
                                :key="campaign.id" :value="campaign.id">
                                {{ campaign.name }}
                            </option>
                        </select>
                        <p v-if="form.errors.has('campaign_id')" class="invalid-feedback">
                            {{ form.errors.get('campaign_id') }}
                        </p>
                    </div>
                  <div class="row">
                      <div class="col-md-6">
                          <div class="form-group"
                              :class="{'is-invalid': form.errors.has('sync_at')}">
                              <div class="d-flex justify-between">
                                  <label>Sync at</label>
                                  <small class="ml-auto float-right text-muted" style="padding-top: 4px">
                                      Server Time:
                                      <server-time
                                          class="ml-1"
                                          format="hh:mm:ss a"
                                      />
                                  </small>
                              </div>

                              <vue-ctk-date-time-picker
                                  v-model="form.sync_at"
                                  label="Select time"
                                  :no-label="true"
                                  format="hh:mm a"
                                  formatted="hh:mm a"
                                  color="#0374D7"
                                  :minute-interval="1"
                                  :only-time="true"
                              />
                              <p v-if="form.errors.has('sync_at')" class="invalid-feedback">
                                  {{ form.errors.get('sync_at') }}
                              </p>
                          </div>
                      </div>
                      <div class="col-md-6">
                          <div class="form-group"
                              :class="{'is-invalid': form.errors.has('send_at')}">
                              <label>Send invites at</label>
                              <vue-ctk-date-time-picker
                                  v-model="form.send_at"
                                  label="Select time"
                                  :no-label="true"
                                  color="#0374D7"
                                  format="hh:mm a"
                                  formatted="hh:mm a"
                                  :without-header="true"
                                  :minute-interval="15"
                                  :only-time="true"
                              />
                              <p v-if="form.errors.has('send_at')" class="invalid-feedback">
                                  {{ form.errors.get('send_at') }}
                              </p>
                          </div>
                      </div>
                  </div>
                <hr/>
                  <div class="form-group">
                      <legend class="font-weight-bold mb-2">
                          Practices
                      </legend>
                      <toggle-button
                          class="mb-0"
                          :color="{ checked: '#0074d9', unchecked: '#dc3545' }"
                          :sync="true"
                          :labels="{ checked: 'Hide', unchecked: 'Show' }"
                          :width="90"
                          :height="20"
                          :speed="200"
                          v-model="activePractices"
                          @change="togglePractices"
                      />
                      <div v-if="activePractices" :class="{'is-invalid': form.errors.has('practices')}">
                      <div class="mb-3 d-flex align-items-center">
                          <div class="ml-3 custom-control custom-checkbox"
                              v-if="practices.length">
                              <input type="checkbox"
                                  class="custom-control-input"
                                  id="practicesAll"
                                  v-model="practicesAll"
                                  @change="selectAllPractices">
                              <label class="custom-control-label" for="practicesAll">
                                  Select all
                              </label>
                          </div>
                      </div>
                      <p v-if="form.errors.has('practices')" class="invalid-feedback">
                          {{ form.errors.get('practices') }}
                      </p>
                      <template>
                          <card-spinner
                              v-if="loadPractices"
                          />
                          <div class="row" v-if="practices.length && !loadPractices">
                              <div class="col-md-4 checkbox"
                                  v-for="practice in practices" :key="practice.id">
                                  <label class="checkbox-inline px-2">
                                      <input v-model="form.practices" type="checkbox"
                                          :value="practice.id" @change="selectedAllPractices">
                                      {{ practice.name }} <small class="text-secondary"><em>(ID: {{practice.id}})</em></small>
                                  </label>
                              </div>
                          </div>
                      </template>
                    </div>
                  </div>

                  <hr/>
                  <div class="form-group"
                      :class="{'is-invalid': form.errors.has('providers')}">
                          <legend class="m-0 w-auto font-weight-bold">
                              Providers
                          </legend>
                          <div v-if="providers.length">
                          <toggle-button
                              class="mb-0"
                              :color="{ checked: '#0074d9', unchecked: '#dc3545' }"
                              :sync="true"
                              :labels="{ checked: 'Hide', unchecked: 'Show' }"
                              :width="90"
                              :height="20"
                              :speed="200"
                              v-model="activeProviders"
                              @change="toggleProviders"
                          />
                        </div>
                        <div v-if="activeProviders">
                          <div class="mb-3 d-flex align-items-center">
                          <div class="ml-3 custom-control custom-checkbox"
                              v-if="providers.length">
                              <input type="checkbox"
                                  class="custom-control-input"
                                  id="providersAll"
                                  v-model="providersAll"
                                  @change="selectAllProviders">
                              <label class="custom-control-label" for="providersAll">
                                  Select all
                              </label>
                          </div>
                      </div>
                      <p v-if="form.errors.has('providers')" class="invalid-feedback">
                          {{ form.errors.get('providers') }}
                      </p>
                      <div class="row">
                          <div class="col-md-12" v-if="!providers.length">
                              <div v-if="loadProviders">
                                  <card-spinner></card-spinner>
                              </div>
                          </div>
                          <div class="col-md-4 checkbox"
                              v-for="provider in providers"
                              :key="provider.id">
                              <label class="checkbox-inline px-2">
                                  <input v-model="form.providers" type="checkbox"
                                      :value="provider.id"
                                      @change="selectedAllProviders">
                                  {{ provider.firstName }}
                                  {{ provider.middleName }}
                                  {{ provider.lastName }}
                                  <small class="text-secondary"><em>(ID: {{provider.id}})</em></small>
                              </label>
                          </div>
                      </div>
                    </div>
                  </div>
                  <hr/>
                  <div class="form-group"
                      :class="{'is-invalid': form.errors.has('appointment_statuses')}">
                          <legend class="m-0 w-auto font-weight-bold">
                              Appointment statuses
                          </legend>
                          <div v-if="appointmentStatuses.length">
                          <toggle-button
                              class="mb-0"
                              :color="{ checked: '#0074d9', unchecked: '#dc3545' }"
                              :sync="true"
                              :labels="{ checked: 'Hide', unchecked: 'Show' }"
                              :width="90"
                              :height="20"
                              :speed="200"
                              v-model="activeAppointmentStatuses"
                              @change="toggleAppointments"
                          />
                        </div>
                        <div v-if="activeAppointmentStatuses">
                          <div class="mb-3 d-flex align-items-center">
                          <div class="ml-3 custom-control custom-checkbox"
                              v-if="appointmentStatuses.length">
                              <input type="checkbox"
                                  class="custom-control-input"
                                  id="appointmentsAll"
                                  v-model="appointmentStatusesAll"
                                  @change="selectAllAppointments">
                              <label class="custom-control-label" for="appointmentsAll">
                                  Select all
                              </label>
                          </div>
                      </div>
                      <p v-if="form.errors.has('appointment_statuses')" class="invalid-feedback">
                          {{ form.errors.get('appointment_statuses') }}
                      </p>
                      <div class="row">
                          <div class="col-md-12" v-if="!appointmentStatuses.length">
                              <div v-if="loadAppointmentStatuses">
                                  <card-spinner></card-spinner>
                              </div>
                          </div>
                          <div class="col-md-4 checkbox"
                              v-for="appointmentStatus in appointmentStatuses"
                              :key="appointmentStatus.id">
                              <label class="checkbox-inline px-2">
                                  <input v-model="form.appointment_statuses" type="checkbox"
                                      :value="appointmentStatus"
                                      @change="selectedAllAppointments">
                                  {{ appointmentStatus }}
                              </label>
                          </div>
                      </div>
                    </div>
                  </div>
                </div> <!-- end of editmode -->
              </div> <!-- end of integrated -->
            </transition>

            <transition name="fade-in-down">
              <div v-if="!loading">
                <div v-if="!integrated">
                  <div class="form-horizontal">
                    <div class="form-row">
                        <input-text
                            class="col-md-6"
                            label="API-AUTH-KEY"
                            field="carestack_key"
                            v-model="location_form.carestack_key"
                            :form="location_form"
                        />
                        <div class="form-group col-md-6">
                          <input-text
                              class="col-md-6"
                              label="ACCOUNT-ID"
                              field="carestack_account_id"
                              v-model="location_form.carestack_account_id"
                              :form="location_form"
                          />
                        </div>
                    </div>
                    <div class="form-row">
                        <input-text
                            class="col-md-12"
                            label="Account URL Subdomain * https://{Account-URL-Subdomain}.carestack.com"
                            field="carestack_url_type"
                            v-model="location_form.carestack_url_type"
                            :form="location_form"
                        />
                    </div>
                  </div>
                </div>
              </div>
            </transition>
            <card-spinner
                v-if="loading"
                style="height:200px"
            />
            <div v-if="!integrated">
              <div class="modal-footer mt-2 pr-0 pb-0 pl-0">
                  <button class="btn btn-default" type="button" data-dismiss="modal">
                      Close
                  </button>
                  <button-loading type="button" class="btn btn-primary ml-2"
                      :loading="location_form.submitting"
                      @click="carestackAuthenticate">
                      Verify Credentials
                  </button-loading>
              </div>
            </div>
            <div v-if="editMode">
              <div class="modal-footer mt-2 pr-0 pb-0 pl-0">
                  <button class="btn btn-default"
                          type="button"
                          data-dismiss="modal"
                          @click="exitEdit()">
                  Close
                  </button>
                  <button-loading type="button" class="btn btn-primary ml-2"
                      :loading="form.submitting"
                      @click="saveIntegration">
                      Save
                  </button-loading>
              </div>
            </div>
        </modal>
    </div>
</template>
<script>
    import axios from 'axios';
    import isEqual from 'lodash';
    import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
    import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';

    export default {
        props: {
            location: {required: true}
        },
        components: {
            VueCtkDateTimePicker
        },
        data: () => ({
            loading: true,
            loadingInstance: false,
            transitioning: false,
            verified: false,
            carestackConnections: [],
            campaigns: [],

            selectedConnection: null,
            logs: [],
            query: null,
            loadingLogs: false,

            editMode: false,
            logsMode: false,
            location_form: new Form({}),
            form: new Form({}),

            loadAppointmentStatuses: false,
            appointmentStatuses: [],
            appointmentStatusesAll: false,
            activeAppointmentStatuses: true,

            loadPractices  : true,
            activePractices: true,
            practicesAll   : false,
            practices      : [],

            loadProviders  : true,
            activeProviders: true,
            providersAll   : false,
            providers      : []
        }),
        watch: {
            location: {
                immediate: true,
                handler() {
                    this.location_form = new Form({
                        id: this.location.id,
                        carestack_key: this.location.carestack_key,
                        carestack_account_id: this.location.carestack_account_id,
                        carestack_subdomain: this.location.carestack_url_type
                    });
                }
            }
        },
        computed: {
            integrated() {
                let is_integrated = !!this.location && !!this.location.carestack_key || this.verified;
                return is_integrated;
            },
            empty() {
              return !this.carestackConnections.length && !this.transitioning;
            },
            practiceSelected() {
              return this.form.practices && !this.form.practices.length;
            },
        },

        methods: {
            async open() {
                this.$refs.modal.open();
                this.$emit('show', true);
                if(this.integrated){
                  this.getCarestackConnections();
                }
                this.campaigns = this.location.campaigns;
                this.loading = false;
            },

            close() {
                this.$emit('hide');
                this.$emit('save-integration', this.location.id);
                this.logsMode           = false;
                this.selectedConnection = null;
                this.exitEdit();
            },

            statusClassOf(appointment) {
                return {
                    'badge-success': appointment.result_status === 'success',
                    'has-more badge-danger cursor-pointer': appointment.result_status === 'failed',
                    'has-more badge-secondary cursor-pointer': appointment.result_status === 'filter-off',
                    'has-more badge-warning cursor-pointer': appointment.result_status === 'patient-not-found',
                };
            },

            tooltipFor(appointment) {
                const errors = appointment.errors;
                return appointment.errors.length ?
                    {title: errors && errors.length && errors[0]} :
                    null;
            },

            async loadLogs(connection) {

                this.selectedConnection = connection;
                this.logsMode = true;
                await this.fetchAppointmentLogs();
            },

            async fetchAppointmentLogs(page = 1) {
                try {
                    this.loadingLogs = true;
                    const params     = {page, search: this.query};
                    const {data: logs} = await this.$http.get(`/carestack/${this.selectedConnection.id}/getAppointmentLogs`, {params});
                    this.logs = logs;
                } catch (e) {
                    console.error('Unable to load logs: ', e);
                } finally {
                    this.loadingLogs = false;
                }
            },

            async closeLogs() {
                this.logsMode = false;
            },

            exitEdit() {
              this.editMode = false;
              this.form     = new Form({});
            },

            async remove(connection, evt) {
                evt.target.parentElement.blur();
                const result = await this.$confirmDialog();
                if (!result) return;
                try {
                    await this.$http.delete(this.$laroute.route('carestack.removeIntegration', {
                        carestackIntegration: connection.id
                    }));
                    const index = this.carestackConnections.findIndex(c => c.id === connection.id);
                    this.transitioning = true;
                    this.carestackConnections.splice(index, 1);
                    swal.close();
                } catch (e) {
                    console.error('Unable to delete carestack connection!', e);
                    if (!e.response) {
                        swal.fire("Operation failed!", e.message, "error");
                        return;
                    }

                    const response = e.response;
                    if (response.status === 500) {
                        swal.fire("Operation failed!",
                            'Sorry, an unexpected condition was encountered. Please try again later. ' +
                            'If the problem persists, please contact customer support.',
                            "error");
                        return;
                    }

                    swal.fire("Operation failed!", response.data.message, "error");
                }
            },

            async getCarestackConnections() {
                await this.$http.get(this.$laroute.route('carestack.getIntegrations', {
                    location: this.location.id
                }))
                    .then(({data}) => {
                      this.carestackConnections = data.data;
                    }).catch(error => console.error(error));
                this.loading = false;
            },

            async location_save() {
                const request = this.location_update();
                return request.then(({data}) => {
                    swal.fire({
                        title: 'Connection Confirmed!',
                        type: 'success',
                    })
                    this.verified = true;
                    this.loading = true;
                    this.getCarestackConnections();
                    this.loading = false;
                })
                .catch(error => console.error(error));
            },

            location_update() {
                return this.location_form.put(this.$laroute.route('location-carestack-integration.update', {location: this.location_form.id}));
            },

            async carestackAuthenticate(){
              this.loading = true;
              await this.location_form.post(this.$laroute.route('carestack.authenticate'))
                  .then(({data}) => {
                      if(data['is_authenticated']){
                         this.location_save();
                      }else{
                        this.verified = false;
                        swal.fire({
                            title: 'Failed To Integrate',
                            type: 'error',
                            message: 'Please check api credentials and try again.'
                        })
                      }
                      this.loading = false;
                  })
                .catch(error => {
                  console.error(error);
                  this.loading = false;
                });
            },
            //
            async removeCarestackCredentials(){
              const result = await this.$confirmDialog();
              if (!result) return;
              this.loading = true;
              const request = this.location_form.put(this.$laroute.route('location-carestack-integration.remove', {location: this.location_form.id}));
              return request.then(({data}) => {
                this.verified = false;
                this.loading = false;
                this.$emit('save-integration', data.id);
                swal.fire({
                    title: 'Carestack Credentials Removed',
                    type: 'warning',
                });
                this.$refs.modal.close();
              })
              .catch(error => console.error(error));
            },
            //
            async startEdit(item){
              this.practices = [];
              this.practicesAll = false;
              this.appointmentStatuses = [];
              this.appointmentStatusesAll = false;
              this.providers = [];
              this.providersAll = false;
              this.loading = false;
              this.editMode = true;
              this.form = new Form({
                  id                   : item ? item.id : null,
                  location_id          : item ? item.location_id : this.location.id,
                  instance_id          : item ? item.instance_id : null,
                  campaign_id          : item ? item.campaign_id : null,
                  sync_at              : item ? item.sync_at : '12:00 am',
                  send_at              : item ? item.send_at : '12:00 am',
                  appointment_statuses : item ? item.appt_statuses : [],
                  all_statuses         : item ? item.all_appt_statuses: false,
                  practices            : item ? item.locations : [],
                  all_practices        : item ? item.all_locations: false,
                  providers            : item ? item.providers: [],
                  all_providers        : item ? item.all_providers: false
              });
              var startEdit = true;
              if(this.form.id){
                startEdit = false;
              }
              this.loadInstance(startEdit);

            },

            async loadInstance(startEdit = false)
            {
              this.loadingInstance = true;
              this.loadPractices = true;
              this.loadProviders = true;
              try{
                  this.activePractices = true;
                  this.fetchingPractices().then(() => {
                  });
                  this.activeAppointmentStatuses = true;
                  this.fetchAppointmentStatuses().then(() => {
                  });
                  this.activeProviders = true;
                  this.fetchProviders().then(() => {
                  });
              } catch (e) {
                  console.error(e);
              } finally {
              }
              this.loadingInstance = false;
            },

            async saveIntegration(){
              this.loading = true;
              try{
                if(this.form.id){
                this.form.put(this.$laroute.route('carestack.updateIntegration'))
                  .then(() => {
                    this.getCarestackConnections();
                    swal.fire({
                        title: 'Saved',
                        type: 'success',
                    });
                    this.editMode = false;
                  });
                }else{
                this.form.post(this.$laroute.route('carestack.createIntegration'))
                  .then(() => {
                    this.getCarestackConnections();
                    swal.fire({
                        title: 'Saved',
                        type: 'success',
                    });
                    this.editMode = false;
                  });
                }

              } catch (e) {
                  console.error(e);
              } finally {
                this.loading = false;
              }
            },

            async fetchProviders(){
              this.loadProviders = true;
              await this.$http.get(this.$laroute.route('carestack.getProviderList', {
                  location: this.location.id
              }))
                  .then(({data}) => {
                      this.providers = data.data;
                      this.loadProviders = false;
                      this.selectedAllProviders();
                  });
            },

            selectAllProviders() {
                if (this.providersAll) {
                    this.form.providers = this.providers.map((provider) => provider.id);
                    this.form.all_providers = true;
                    return;
                }
                this.form.providers = [];
                this.form.all_providers = true;
            },

            selectedAllProviders() {
                let providerIds = this.providers.map((provider) => provider.id);
                if (_.isEqual(_.sortBy(providerIds), _.sortBy(this.form.providers))) {
                    this.providersAll = true;
                    this.form.all_providers = true;
                    return;
                }
                this.providersAll = false;
                this.form.all_providers = false;
            },

            async fetchingPractices(){
              this.loadPractices = true;
              await this.$http.get(this.$laroute.route('carestack.getLocationList', {
                  location: this.location.id
              }))
                  .then(({data}) => {
                      this.practices = data.data;
                      this.loadPractices = false;
                      this.selectedAllPractices();
                  });
            },

            selectAllPractices() {
                if (this.practicesAll) {
                    this.form.practices = this.practices.map((practice) => practice.id);
                    this.form.all_practices = true;
                    return;
                }
                this.form.practices = [];
                this.form.all_practices = true;
            },

            selectedAllPractices() {
                let practiceIds = this.practices.map((practice) => practice.id);
                if (_.isEqual(_.sortBy(practiceIds), _.sortBy(this.form.practices))) {
                    this.practicesAll = true;
                    this.form.all_practices = true;
                    return;
                }
                this.practicesAll = false;
                this.form.all_practices = true;
            },

            async fetchAppointmentStatuses() {
              this.loadAppointmentStatuses = true;
              await this.$http.get(this.$laroute.route('carestack.getAppointmentStatuses', {
                  location: this.location.id
              }))
                  .then(({data}) => {
                      this.appointmentStatuses = data.data;
                      this.loadAppointmentStatuses = false;
                      this.selectedAllAppointments();
                  });
            },

            selectAllAppointments() {
                if (this.appointmentStatusesAll) {
                    this.form.appointment_statuses = this.appointmentStatuses.map((appointmentStatus) => appointmentStatus);
                    this.form.all_statuses = true;
                    return;
                }
                this.form.appointment_statuses = [];
                this.form.all_statuses = false;
            },

            selectedAllAppointments() {
                let appointmentIds = this.appointmentStatuses.map((appointmentStatus) => appointmentStatus);
                if (_.isEqual(_.sortBy(appointmentIds), _.sortBy(this.form.appointment_statuses))) {
                    this.appointmentStatusesAll = true;
                    this.form.all_statuses = true;
                    return;
                }
                this.appointmentStatusesAll = false;
                this.form.all_statuses = false;
            },

            toggleProviders() {
              if(this.activeProviders){
              }
            },

            togglePractices() {
              if(this.activePractices){
              }
            },

            toggleAppointments() {
              if(this.activeAppointmentStatuses){
              }
            },

            async transitioningDone() {
                setTimeout(() => {
                    this.transitioning = false
                }, 500);
            },
        }
    }
</script>

<style lang="scss" scoped>
    legend {
        font-size: 1rem;
    }

    .table th, .table td {
        white-space: nowrap;
        font-size: small;
    }

    .carestack {
        min-height: 90px;
        filter: grayscale(100%);
        background-repeat: no-repeat;
        background-size: contain;
        opacity: 0.6;
        background-position-y: center;
        background-position-x: center;

        &:hover {
            filter: grayscale(0%);
            opacity: 0.8;
        }

        &.active {
            filter: grayscale(0%);
            opacity: 1;
        }
    }

    .is-invalid {
        .invalid-feedback {
            display: block;
        }
    }

</style>

<style lang="scss">
    .date-time-picker {
        .field-input {
            color: #6e7d87;
            font-weight: 600;
            font-size: 16px;
            font-family: "open sans", Whitney, Lato, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
            border: 1px solid #b0b9bf !important;

            &:focus {
                border-color: #5db2fd;
                box-shadow: 0 0 0 0.2rem rgba(3, 116, 215, .25);
            }
        }
    }

    .alert span {
      vertical-align: middle;
      line-height:normal;
    }

    .alert > div {
      line-height: 34px;
    }
</style>
